import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import * as configActions from 'modules/config';
import * as adminActions from 'modules/admin';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';

import { ConfigLDAP } from 'components';

class CtConfigLDAP extends Component {
  constructor(props) {
    super(props);

    this.state = {
      connectReseult: { isReseult: 0, message: '' },
      isModal: false,
      onProgress: false
    };
  }

  onToggleModal = type => {
    this.setState({ isModal: type });
  };

  connLDAP = async () => {
    this.setState({ onProgress: true });
    try {
      const { ConfigActions } = this.props;
      if (ConfigActions) {
        const respObj = await ConfigActions.getConnLDAP();
        //await ConfigActions.getConnLDAP();

        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data.list) {
            const {
              noService,
              noConnect,
              noModule,
              alreadyExist,
              addCount,
              editCount,
              deleteCount,
              errorCount,
              serviceNo,
              serviceName,
              serviceOwner,
              regDate
            } = respObj.data.list;
            
            if (!!noConnect || !!noService || !!noModule) {
              // 연동 실패
              this.setState({
                connectReseult: {
                  isReseult: 2,
                  resultData: {
                    noService,
                    noConnect,
                    noModule
                  }
                }
              });
            } else {
              // 연동 성공
              this.setState({
                connectReseult: {
                  isReseult: 1,
                  resultData: {
                    noService,
                    noConnect,
                    alreadyExist,
                    addCount,
                    editCount,
                    deleteCount,
                    errorCount,
                    serviceNo,
                    serviceName,
                    serviceOwner,
                    regDate
                  }
                }
              });
            }
          } else if (Array.isArray(respObj.data.error)) {
            // 업로드 실패
          }
        } else {
          // 업로드 에러
        }
      }
    } catch (e) {
      console.log(e);
    }
    this.setState({ onProgress: false, isModal: true });
  };

  render() {
    const { connLDAP, onToggleModal } = this;
    const { isModal, onProgress } = this.state;

    return (
      <ConfigLDAP
        isModal={isModal}
        onProgress={onProgress}
        onToggleModal={onToggleModal}
        connLDAP={connLDAP}
        LDAPConnectResult={this.state.connectReseult}
      />
    );
  }
}

CtConfigLDAP.propTypes = {};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  ConfigActions: bindActionCreators(configActions, dispatch),
  AdminActions: bindActionCreators(adminActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtConfigLDAP);



// WEBPACK FOOTER //
// ./src/script/containers/config/CtConfigLDAP.js